namespace TabAurous.Retail {
    export namespace TopBrandsService {
        export const baseUrl = 'POSSales/TopBrands';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/TopBrands/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopBrandsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
